import DashboardLayout from "../../layout/Layout";
import { useCallback, useEffect, useState } from "react";
import Api from "../../api/api";
import { decrypt } from "../../helpers/functions";

const AdminDashboard = () => {
  const [quiz, setQuiz] = useState(null);

  useEffect(() => {
    getTodayQuiz();
  }, []);

  async function getTodayQuiz() {
    const res = await Api.todayQuiz();
    if (res.status === 200) {
      const data = await decrypt(res?.data?.data);
      setQuiz(data);
    }
  }

  return (
    <DashboardLayout title="Dashboard">
      <div className="mt-10 p-10 text-center">
        <h1 className="font-bold text-2xl">Today Quiz</h1>
        <br />
        <br />
        <p>{quiz?.question}</p>
      </div>
    </DashboardLayout>
  );
};

export default AdminDashboard;
